jQuery(document).ready(() => {

	const button = jQuery(`[data-filter='button']`);

	// Show Filter
	//////////////////////////////////////////////////////////////////////////////////////

	button.each(function () {

		jQuery(this).click(() => {

			const box = jQuery(this).next('.filter__box');
			box.addClass('active');
			jQuery('body').addClass('scroll-hidden');

		});

	});

	// Hide Filter
	//////////////////////////////////////////////////////////////////////////////////////

	const close = jQuery(`[data-filter='close']`);

	close.each(function() {
		
		jQuery(this).click(() => {

			const box = jQuery(this).parent('.title').parent('.filter__box');
			box.removeClass('active');
			jQuery('body').removeClass('scroll-hidden');

		});

	});

	// Activate Accordion
	//////////////////////////////////////////////////////////////////////////////////////

	const item_accordion = jQuery(`[data-filter='accordion']`);

	item_accordion.each(function () {

		jQuery(this).click(() => {

			const sub_items = jQuery(this).next('.list-files__months');
			const icon = jQuery(this).children('.icon');

			sub_items.slideToggle();

			if (icon.hasClass('icon-icon-chevron-down')) {
				icon.removeClass('icon-icon-chevron-down');
				icon.addClass('icon-icon-chevron-up');
			} else {
				icon.addClass('icon-icon-chevron-down');
				icon.removeClass('icon-icon-chevron-up');
			}

		});

	});

});